/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Admin_Billing_Enable_Desc_PileInputs */



/**
* | output |
* | --- |
* | "{name} has {count} closed monthly reports that have never been invoiced, totalling {amount}. Choose what happens to that history — this cannot be undone." |
*
* @param {Partner_Admin_Billing_Enable_Desc_PileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_enable_desc_pile = /** @type {((inputs: Partner_Admin_Billing_Enable_Desc_PileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Enable_Desc_PileInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Für ${i?.name} liegen ${i?.count} abgeschlossene Monatsberichte über insgesamt ${i?.amount} vor, die noch nie abgerechnet wurden. Entscheiden Sie, was mit dieser Historie geschieht — das lässt sich nicht rückgängig machen.`)
	return /** @type {LocalizedString} */ (`${i?.name} has ${i?.count} closed monthly reports that have never been invoiced, totalling ${i?.amount}. Choose what happens to that history — this cannot be undone.`)
});